"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _color = _interopRequireDefault(require("@decisiv/design-tokens/lib/color"));

var _spacing = _interopRequireDefault(require("@decisiv/design-tokens/lib/spacing"));

var _typography = _interopRequireDefault(require("@decisiv/design-tokens/lib/typography"));

var _ChevronDown = _interopRequireDefault(require("@decisiv/iconix/lib/components/ChevronDown"));

var _ChevronUp = _interopRequireDefault(require("@decisiv/iconix/lib/components/ChevronUp"));

var _toColorString = _interopRequireDefault(require("polished/lib/color/toColorString"));

var _rem = _interopRequireDefault(require("polished/lib/helpers/rem"));

var _react = _interopRequireDefault(require("react"));

var _styledComponents = _interopRequireWildcard(require("styled-components"));

var _styledComponentsModifiers = require("styled-components-modifiers");

var _focusRingWithColor = _interopRequireDefault(require("../../utils/focusRingWithColor"));

var _useTranslations = _interopRequireDefault(require("../../utils/useTranslations"));

var _Flex = _interopRequireDefault(require("../Flex"));

var _Grid = _interopRequireDefault(require("../Grid"));

var _Tooltip = _interopRequireDefault(require("../Tooltip"));

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {}; if (desc.get || desc.set) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var HR = _styledComponents.default.hr.withConfig({
  displayName: "ItemHeader__HR",
  componentId: "gu84p2-0"
})(["border:none;border-top:1px solid ", ";margin:0;& ~ *{margin:0;}"], (0, _toColorString.default)(_color.default.base.quarterMoon));

var ItemTitle = (0, _styledComponents.default)(_Flex.default).withConfig({
  displayName: "ItemHeader__ItemTitle",
  componentId: "gu84p2-1"
})(["white-space:pre-wrap;"]);

var ItemHeaderButton = _styledComponents.default.button.withConfig({
  displayName: "ItemHeader__ItemHeaderButton",
  componentId: "gu84p2-2"
})(["align-items:center;background:transparent;border:1px solid transparent;color:", ";display:flex;font-size:", ";font-weight:", ";justify-content:space-between;padding:", " ", ";text-align:left;width:100%;&:focus{border-color:", ";", ";outline:none;}&:hover{color:", ";}&:disabled{color:", ";cursor:not-allowed;}", ""], (0, _toColorString.default)(_color.default.interaction.pacificOcean), (0, _rem.default)(_typography.default.size.scale[2]), _typography.default.weight.alias.medium, (0, _rem.default)(_spacing.default.base), (0, _rem.default)(_spacing.default.base * 2), (0, _toColorString.default)(_color.default.interaction.pacificOcean), (0, _focusRingWithColor.default)(_color.default.interaction.pacificOcean40), (0, _toColorString.default)(_color.default.interaction.indianOcean), (0, _toColorString.default)(_color.default.opacity.charcoal40), (0, _styledComponentsModifiers.applyStyleModifiers)({
  medium: function medium() {
    return (0, _styledComponents.css)(["font-size:", ";"], (0, _rem.default)(_typography.default.size.scale[1]));
  }
}, 'size'));

function ItemHeaderIndicator(_ref) {
  var disabled = _ref.disabled,
      expanded = _ref.expanded;
  var translate = (0, _useTranslations.default)();

  if (disabled) {
    return expanded ? _react.default.createElement("span", null, _react.default.createElement(_ChevronUp.default, null)) : _react.default.createElement("span", null, _react.default.createElement(_ChevronDown.default, null));
  }

  return expanded ? _react.default.createElement(_Tooltip.default, {
    target: // eslint-disable-next-line react/jsx-wrap-multilines
    _react.default.createElement("span", null, _react.default.createElement(_ChevronUp.default, null))
  }, translate(undefined, 'accordion.collapse')) : _react.default.createElement(_Tooltip.default, {
    target: // eslint-disable-next-line react/jsx-wrap-multilines
    _react.default.createElement("span", null, _react.default.createElement(_ChevronDown.default, null))
  }, translate(undefined, 'accordion.expand'));
}

var titleHeadingLevelMap = {
  2: 'h2',
  3: 'h3',
  4: 'h4',
  5: 'h5',
  6: 'h6'
};

function ItemHeader(_ref2) {
  var disabled = _ref2.disabled,
      expanded = _ref2.expanded,
      IconComponent = _ref2.icon,
      id = _ref2.id,
      itemHeaderId = _ref2.itemHeaderId,
      itemPanelContainerId = _ref2.itemPanelContainerId,
      size = _ref2.size,
      title = _ref2.title,
      _ref2$titleHeadingLev = _ref2.titleHeadingLevel,
      titleHeadingLevel = _ref2$titleHeadingLev === void 0 ? '3' : _ref2$titleHeadingLev,
      toggle = _ref2.toggle;
  return _react.default.createElement(_react.default.Fragment, null, _react.default.createElement(HR, null), _react.default.createElement(_Grid.default.Row, {
    as: titleHeadingLevelMap[titleHeadingLevel]
  }, _react.default.createElement(ItemHeaderButton, {
    "aria-controls": itemPanelContainerId,
    "aria-disabled": disabled,
    "aria-expanded": expanded,
    disabled: disabled,
    id: itemHeaderId,
    onClick: function onClick() {
      return toggle(id);
    },
    size: size,
    type: "button"
  }, _react.default.createElement(_Flex.default, {
    alignItems: "center"
  }, IconComponent && _react.default.createElement(_Flex.default, {
    marginRight: 1
  }, _react.default.createElement(IconComponent, null)), _react.default.createElement(ItemTitle, {
    flex: 1,
    marginRight: 1
  }, title)), _react.default.createElement(ItemHeaderIndicator, {
    disabled: disabled,
    expanded: expanded
  }))));
}

var _default = ItemHeader;
exports.default = _default;